import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/useAuth.js';
import { ROLE_LABELS } from '../validation/roles.js';

function initials(name = '') {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
}

function UserChip() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  const signOut = async () => {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="user-chip-wrap">
      <button
        type="button"
        className="user-chip"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <div className="avatar" aria-hidden="true">
          {initials(user.name)}
        </div>
        <span className="user-chip-text">
          <span className="user-chip-name">{user.name}</span>
          <span className="user-chip-role">{ROLE_LABELS[user.role] || user.role}</span>
        </span>
      </button>

      {open && (
        <>
          {/* Click anywhere else to close. */}
          <button type="button" className="menu-backdrop" aria-label="Close menu" onClick={() => setOpen(false)} />
          <div className="user-menu" role="menu">
            <div className="user-menu-head">
              <div className="user-menu-name">{user.name}</div>
              <div className="user-menu-email">{user.email}</div>
            </div>
            <Link className="user-menu-item" role="menuitem" to="/account" onClick={() => setOpen(false)}>
              My Account
            </Link>
            <button type="button" className="user-menu-item danger" role="menuitem" onClick={signOut}>
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <header className="topbar">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1>{title}</h1>
        {subtitle && <div className="page-subtitle">{subtitle}</div>}
        <svg className="strand" viewBox="0 0 120 11" fill="none" aria-hidden="true">
          <path
            d="M2 5.5c5-7 9-7 14 0s9 7 14 0 9-7 14 0 9 7 14 0 9-7 14 0 9 7 14 0"
            stroke="#C9A15A"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <UserChip />
    </header>
  );
}
